module.exports = __webpack_public_path__ + "static/media/image-3.9aa7c877.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Algorithms/image-3.png
// module id = 248
// module chunks = 0